import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { changeLanguage } from '../actions/uiActions';
import ThemeColorSetting from '../constants/themeColor';
import { Menu , Image , Header , Button , Grid , Icon , Modal , Dropdown } from 'semantic-ui-react';
import { Link } from "react-router";
import { browserHistory } from "react-router";
import logo from "../assets/logo.png";

const styles = {
  topBarWrapper : {
    display : 'flex',
    alignItems : 'center',
    height : '12vh',
    borderRadius: '0px',
    backgroundColor : ThemeColorSetting.cyan,
    width : '100%',
    margin : 0
  },
  logo : {
    height : '50px',
    weight : '50px'
  },
  logoName : {
    padding : '0px',
    margin : '0px'
  },
  trialButton : {
    backgroundColor : ThemeColorSetting.red,
    color : 'white'
  }
}

class TopBar extends Component {
  render() {
    const { string , mixpanel , locale , changeLanguage } = this.props;
    return(
      <Menu inverted pointing style={styles.topBarWrapper}>
        <Menu.Item>
          <Link to='/'>
            <Header as="h4" className="ui header inverted">
              <Image src={logo}/>
              <div className="content">
                <p style={styles.logoName}>KIOS.TECH</p>
                <p>{string['subtitle']}</p>
              </div>
            </Header>
          </Link>
        </Menu.Item>
        <Menu.Menu position='right'>
          <Grid padded>
            <Grid.Row>
              <Grid.Column className="mobile tablet only">
                <Modal trigger={<Button icon><Icon name='content'/></Button>} basic size='small'>
                  <Modal.Content>
                    <Menu secondary vertical inverted>
                      <Menu.Item>
                        <Menu.Header>{`Language : ${string[locale]}`}</Menu.Header>
                        <Menu.Menu>
                          <Menu.Item name='zh' active={locale === 'zh'} onClick={()=>changeLanguage('zh')}>繁體中文</Menu.Item>
                          <Menu.Item name='en' active={locale === 'en'} onClick={()=>changeLanguage('en')}>English</Menu.Item>
                        </Menu.Menu>
                      </Menu.Item>
                      <Menu.Item><Link to={{  pathname : '/features' , query : { device : 'mobileDevices' , feature : 'addInvoice' } }} >{string['features']}</Link></Menu.Item>
                      <Menu.Item><Link to={{  pathname : '/pricing' , query : { target : 'hardware' } }}>{string['pricing']}</Link></Menu.Item>
                      <Menu.Item><a href="https://dashboard.kios.tech">{string['linkToAdminPanel']}</a></Menu.Item>
                      <Menu.Item><a href="https://dashboard.kios.tech/auth/signup">{string['signupNow']}</a></Menu.Item>
                    </Menu>
                  </Modal.Content>
                 </Modal>
              </Grid.Column>
              <Grid.Column style={{ display : 'flex' , flexDirection : 'row' }} className="computer only">
                <Menu.Item><Link to={{  pathname : '/features' , query : { device : 'mobileDevices' , feature : 'addInvoice' } }} >{string['features']}</Link></Menu.Item>
                <Menu.Item><Link to={{  pathname : '/pricing' , query : { target : 'hardware' } }}>{string['pricing']}</Link></Menu.Item>
                <Menu.Item>
                  <a id="#signup" href="https://dashboard.kios.tech">
                    <Button onClick={()=>{mixpanel.track("Top Bar", { action : 'login' })}} color='black'>{string['linkToAdminPanel']}</Button>
                  </a>
                  <a id="#login" href="https://dashboard.kios.tech/auth/signup">
                    <Button onClick={()=>{mixpanel.track("Top Bar", { action : 'signup' })}} style={styles.trialButton}>{string['signupNow']}</Button>
                  </a>
                </Menu.Item>
                <Menu.Item as={Dropdown} text={`Language : ${string[locale]}`}>
                  <Dropdown.Menu>
                    <Dropdown.Item onClick={()=>changeLanguage('zh')}>繁體中文</Dropdown.Item>
                    <Dropdown.Item onClick={()=>changeLanguage('en')}>English</Dropdown.Item>
                  </Dropdown.Menu>
                </Menu.Item>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Menu.Menu>
      </Menu>
    )
  }
}

// <Menu.Item><Link to='/fqanda'>{string['faandq']}</Link></Menu.Item>

function mapStateToProps(state) {
  return {
    string : state.preference.string,
    locale : state.preference.locale,
    mixpanel : state.ui.tempData.mixpanel
  }
}

const mapDispatchToProps = (dispatch)=>bindActionCreators({ changeLanguage },dispatch)

export default connect(mapStateToProps,mapDispatchToProps)(TopBar)



/** WEBPACK FOOTER **
 ** ./src/components/topBar.js
 **/